import React, { FC, useEffect, useState } from "react"
import { connect } from "react-redux"

import { USER_PERMISSION } from "../../../constants"
import { RootState } from "../../../store"
import CoManagerButton from "../../ui/header/CoManagerButton"
import Chevron from "./Chevron"
import CoManager from "./CoManager"
import "./CoManager.css"

/**
 * The co-manager over the right half of any page, opened from the header button so the artist does
 * not lose the page they are on to ask something about it.
 *
 * Mounted on the first open and kept after that, so closing and opening it again comes back to the
 * same conversation instead of a fresh greeting. Pages without the header get the same button
 * floating in their corner, which is the only way in from there.
 */
const CoManagerDrawer: FC<{
  open: boolean
  onClose: () => void
  floatingButton: boolean
  coManagerPermission: boolean
}> = ({ open, onClose, floatingButton, coManagerPermission }) => {
  const [mounted, setMounted] = useState(false)
  // Pulled out over most of the page with the arrow on its edge, leaving only the navigation beside it.
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (open) setMounted(true)
  }, [open])

  // The same rule as the header button and the route: without the permission there is nothing to open.
  if (!coManagerPermission) return null

  return (
    <>
      {floatingButton && (
        <div className="co-manager-floating-button">
          <CoManagerButton />
        </div>
      )}
      <div className={`co-manager-drawer-backdrop${open ? " is-open" : ""}`} onClick={onClose} />
      <div
        className={`co-manager-drawer${open ? " is-open" : ""}${expanded ? " is-expanded" : ""}`}
        aria-hidden={!open}
      >
        <button
          type="button"
          className="co-manager-drawer-handle"
          data-testid="co-manager-drawer-expand"
          onClick={() => setExpanded(!expanded)}
        >
          <Chevron direction={expanded ? "right" : "left"} />
        </button>
        {mounted && <CoManager embedded onClose={onClose} />}
      </div>
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  coManagerPermission: !!state.auth.user.permissionUser?.some(
    (item: any) => item.permission && item.permission.id === USER_PERMISSION.CO_MANAGER
  )
})

export default connect(mapStateToProps)(CoManagerDrawer)
